import { MessageDescriptor } from 'react-intl';

import Label from './Label';
import { createDictionary } from 'utils/objectUtils';

export enum YesNoChoice {
  YES = 'YES',
  NO = 'NO',
}

export enum QuestionType {
  YES_NO = 'YES_NO',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  INFORMATION = 'INFORMATION',
}

export const questionResponseProperty = createDictionary<QuestionType, 'response'|'responses'>({
  [QuestionType.MULTIPLE_CHOICE]:'responses',
}, 'response');

export interface QuestionChoice {
  id: string;
  value: Label;
}

interface GenericQuestion {
  id: string;
  description?: Label;
  mandatory: boolean;
  title: MessageDescriptor | Label;
  type: QuestionType;
  response?: YesNoChoice | string;
  responses?: string[];
  choices?: QuestionChoice[];
  comment?: string;
}

export default GenericQuestion;

export const booleanToYesNoChoice =
  (value: boolean | undefined) => value === true ? YesNoChoice.YES : (value === false ? YesNoChoice.NO : undefined);

export const yesNoChoiceToBoolean =
  (value: YesNoChoice | undefined) => value === YesNoChoice.YES ? true : (value === YesNoChoice.NO ? false : undefined);
